import { useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connectToHubWorkerStatus } from "src/redux/slices/hub";
import { upsertWorker } from "src/redux/slices/workerStatus";
import { receiveResults } from "src/redux/slices/printerDiscovery";
import buildHubUrl from "./buildHubUrl";
import CreateConnection from "./HubMatrix";

/**
 * Se suscribe a <c>WorkerStatusHub</c> — el backend empuja:
 *   - <c>workerStatus/{id}</c>       → upsertWorker (Fase 2)
 *   - <c>discovery/results/{id}</c>  → receiveResults del wizard (Fase 3B)
 *
 * Ambos eventos viajan por el mismo hub para reusar infraestructura.
 */
export default function useHubWorkerStatus() {
  const dispatch = useDispatch();
  // Sólo el id — antes usábamos `user` (objeto completo) como dep y CADA
  // `updateUser(...)` desde el flujo de settings/notifs cambiaba la
  // referencia → el effect se re-ejecutaba → cleanup + reopen del hub.
  // Con `user?.id` la conexión sólo se abre/cierra cuando cambia el
  // restaurante (login / logout / cambio de tenant).
  const userId = useSelector((state) => state.authJwt.user?.id);
  const isConnectedRef = useRef(false);

  const handleWorkerStatus = useCallback(
    (statusDto) => {
      dispatch(upsertWorker(statusDto));
    },
    [dispatch],
  );

  const handleDiscoveryResults = useCallback(
    (batch) => {
      dispatch(receiveResults(batch));
    },
    [dispatch],
  );

  useEffect(() => {
    if (!userId || isConnectedRef.current) return;
    isConnectedRef.current = true;

    const cleanup = CreateConnection(
      buildHubUrl("/hub/workerstatus", { restauranteId: userId }),
      [
        {
          id: `workerStatus/${userId}`,
          operator: handleWorkerStatus,
        },
        {
          id: `discovery/results/${userId}`,
          operator: handleDiscoveryResults,
        },
      ],
      dispatch,
      connectToHubWorkerStatus,
      "workerStatus",
    );

    return () => {
      cleanup();
      isConnectedRef.current = false;
    };
  }, [userId, dispatch, handleWorkerStatus, handleDiscoveryResults]);
}
